import React, { useEffect } from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { bindLogger } from 'helpers/BindLogger';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setPcdChange } from 'actions/protocols/protocoldetail';
import { withAppContext } from '@ctsu/loader';
import { httpStatusEnum } from 'appconstants';
import { GetFromCtxValue } from 'helpers';
import { openSnackbar } from 'helpers/Notifier';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import { CanUserEditPCDDates } from 'appconstants/Permission';
import PropTypes from 'prop-types';
import ViewPCD from './ViewPCD';
import EditPCD from './EditPCD';

const PCDInfo = props => {
  const {
    state,
    setState,
    grpProtStatusDate,
    grpProtStatus,
    completionDates,
    onSavePcdChange,
    prtInfo,
    multiPhase
  } = props;

  useEffect(() => {
    setState(false);
  }, [prtInfo, setState]);

  return (
    <RenderEditable
      state={state}
      editable={CanUserEditPCDDates()}
      setState={setState}
      title="Completion Dates"
    >
      <RenderElement access={state === true}>
        <EditPCD
          completionDates={completionDates}
          grpProtStatus={grpProtStatus}
          grpProtStatusDate={grpProtStatusDate}
          onSetPcd={onSavePcdChange}
          pcdStatusChange={setState}
          multiPhase={multiPhase}
        />
      </RenderElement>
      <RenderElement access={state === false}>
        <ViewPCD completionDates={completionDates} multiPhase={multiPhase}/>
      </RenderElement>
    </RenderEditable>
  );
};

PCDInfo.propTypes = {
  state: PropTypes.bool,
  setState: PropTypes.func,
  grpProtStatusDate: PropTypes.string,
  grpProtStatus: PropTypes.string,
  completionDates: PropTypes.oneOfType([PropTypes.object]),
  onSavePcdChange: PropTypes.func,
  prtInfo: PropTypes.oneOfType([PropTypes.object])
};

PCDInfo.defaultProps = {
  state: false,
  setState: null,
  grpProtStatusDate: '',
  grpProtStatus: '',
  completionDates: null,
  onSavePcdChange: null,
  prtInfo: null
};

const withConnectState = connect(
  (state, ownProps) => ({ prtInfo: state.prtDetails.prtInfo }),
  dispatch => bindActionCreators(
    {
      onSetPcd: setPcdChange
    },
    dispatch
  )
);

const PCD = compose(
  withConnectState,
  withAppContext,
  withState('state', 'setState', false),
  withHandlers({
    onSavePcdChange: props => data => {
      const {
        context, prtInfo, setState, state, onSetPcd, completionDates
      } = props;
      bindLogger(onSetPcd, context)(data, prtInfo.prtId).subscribe(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          if (data.actualPrimaryComplDate !== completionDates.actualPrimaryComplDate) {
            openSnackbar({
              message: GetFromCtxValue(context, 'PROTOCOL_PCD_SUCCESS'),
              variant: 'success',
              name: 'apcd'
            });
          }
          if (data.phaseTransitionDate !== completionDates.phaseTransitionDate) {
            openSnackbar({
              message: 'Subsequent Phase Activation Date saved successfully.',
              variant: 'success',
              name: 'apcd'
            });
          }
          if (data.anticipatedPrimaryComplDate !== completionDates.anticipatedPrimaryComplDate) {
            openSnackbar({
              message: GetFromCtxValue(context, 'PROTOCOL_APCD_STATUS'),
              variant: 'success',
              name: 'apcd'
            });
          }
          setState(!state);
        }
      });
    }
  })
)(PCDInfo);


export default PCD;
